import { documentPhase, type DocumentStat } from "@/api/queries";
import { cn, runPhaseLabel } from "@/lib/utils";

const TONE_CLASS = {
  pipe: "bg-bank-pipe-wash text-bank-pipe-ink",
  attention: "bg-bank-attention-wash text-bank-attention-ink",
  good: "bg-bank-good-wash text-bank-good-ink",
} as const;

/** The one rendering of a run's Running/Active·review/Settled state — shared by the
 * Ingest screen's runs table and a single run's detail page so the words and the
 * colour behind them can never say two different things for the same document. */
export function RunStateChip({
  doc,
  className,
}: {
  doc: Pick<DocumentStat, "chunks" | "questions">;
  className?: string;
}) {
  const { label, tone } = runPhaseLabel(documentPhase(doc));
  return (
    <span className={cn("rounded-full px-2.5 py-1 text-xs font-semibold", TONE_CLASS[tone], className)}>
      {label}
    </span>
  );
}
